import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '../lib/auth';

export function Layout({ children }: { children: ReactNode }) {
  const { me, logout } = useAuth();
  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-30">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center gap-4">
          <Link to="/" className="flex items-center gap-2 font-bold text-rla-700 text-lg flex-shrink-0">
            <img src="/rla-logo.png" alt="RLA Solutions" className="h-8 sm:h-10 w-auto object-contain" />
            <span className="hidden sm:inline">Mail</span>
          </Link>
          <div className="ml-auto flex items-center gap-3 text-sm">
            <span className="text-slate-700 truncate max-w-[200px]">{me?.email}</span>
            <button onClick={() => void logout()} className="btn-secondary text-sm">Abmelden</button>
          </div>
        </div>
      </header>
      <main className="flex-1 max-w-7xl w-full mx-auto px-3 sm:px-4 py-4 sm:py-6">{children}</main>
      <footer className="text-center text-xs text-slate-400 py-4 border-t border-slate-200 bg-white">
        RLA Mail {new Date().getFullYear()}
      </footer>
    </div>
  );
}
